(() => {
  if (window.__ovMobileBackInitialized) return;
  window.__ovMobileBackInitialized = true;
  const storageKey = 'orvenior.navigation.v1';
  const back = document.querySelector('[data-ov-back]');
  const here = () => location.pathname + location.search;
  const safePath = (value) => {
    if (typeof value !== 'string' || !value) return null;
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^https?:$/.test(url.protocol)
        ? url.pathname + url.search : null;
    } catch { return null; }
  };
  const read = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey));
      if (!Array.isArray(value?.trail)) return { trail: [] };
      return {
        trail: value.trail.filter((item) => item && safePath(item.url) === item.url).slice(-40),
        returningTo: safePath(value.returningTo),
      };
    } catch { return { trail: [] }; }
  };
  const write = (value) => {
    try { sessionStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* Static fallback stays usable. */ }
  };
  let trail = [];
  const updateLink = () => {
    if (!back) return;
    const previous = trail.length > 1 ? trail[trail.length - 2] : null;
    back.href = previous?.url || back.getAttribute('data-ov-fallback');
  };
  if (back) back.setAttribute('data-ov-fallback', back.getAttribute('href'));

  const enter = (restored = false) => {
    const current = here();
    const saved = read();
    const type = performance.getEntriesByType('navigation')[0]?.type;
    const last = saved.trail[saved.trail.length - 1];
    let restoreY = null;
    if (saved.returningTo === current && last?.url === current) {
      trail = saved.trail;
      restoreY = last.y;
    } else if (restored || type === 'back_forward') {
      const index = saved.trail.map((item) => item.url).lastIndexOf(current);
      trail = index >= 0 ? saved.trail.slice(0, index + 1) : [{ url: current, y: 0 }];
    } else if (type === 'reload' && last?.url === current) {
      trail = saved.trail;
    } else {
      const referrer = document.referrer && safePath(document.referrer);
      // Only continue a trail when this document actually came from its last page.
      trail = referrer && last?.url === referrer ? saved.trail : [];
      if (trail[trail.length - 1]?.url !== current) trail.push({ url: current, y: 0 });
    }
    trail = trail.slice(-40);
    write({ trail });
    updateLink();
    if (Number.isFinite(restoreY)) {
      const restore = () => requestAnimationFrame(() => scrollTo(0, restoreY));
      if (document.readyState === 'complete') restore();
      else window.addEventListener('load', restore, { once: true });
    }
  };
  enter();
  window.addEventListener('pageshow', (event) => { if (event.persisted) enter(true); });
  window.addEventListener('pagehide', () => {
    if (!trail.length) return;
    const saved = read();
    // A Back click has already selected its destination; do not overwrite it on exit.
    if (saved.returningTo) return;
    trail[trail.length - 1] = { url: here(), y: scrollY };
    write({ trail });
  });
  back?.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = safePath(back.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    // Use native history only when the browser exposes the actual preceding URL.
    const navigation = window.navigation;
    const previousIndex = navigation?.currentEntry?.index;
    const previousEntry = Number.isInteger(previousIndex) ? navigation.entries()[previousIndex - 1] : null;
    if (previousEntry?.url && safePath(previousEntry.url) === target) {
      history.back();
      return;
    }
    // Older mobile browsers and external entry links use an explicit same-site destination.
    if (trail.length > 1 && trail[trail.length - 2].url === target) {
      trail.pop();
      write({ trail, returningTo: target });
    } else {
      write({ trail: [{ url: target, y: 0 }], returningTo: target });
    }
    location.replace(target);
  });
})();
